import "./membershipExpiryBanner.scss";
import moment from "moment";
import Typography from "../../../../../../../common/Typography";

const MembershipExpiryBanner = ({ expiryDate }) => {
  const isExpired = moment(expiryDate).isBefore(moment(), "day");
  const formatedExpiryDate = moment(expiryDate).format("Do MMM'YY");

  return (
    <div
      className={`membership-shortlink-expiry-banner ${
        isExpired
          ? "membership-shortlink-expiry-banner--expired"
          : "membership-shortlink-expiry-banner--active"
      }`}
    >
      <Typography weight="medium" customClass="expriy-text">
        Membership {isExpired ? "expired on" : "valid till"}{" "}
        {formatedExpiryDate}
      </Typography>
      <Typography size="text-xs" weight="medium" customClass="status-text">
        {isExpired ? "Expired" : "Active"}
      </Typography>
    </div>
  );
};
export default MembershipExpiryBanner;
